import { filter, map, Observable, of, switchMap, take } from 'rxjs';
import { Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AppRoutes, AUTH_CLIENT_TOKEN, AuthClientProvider, USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { ShouldShowIntroductionQueryHandler } from '../handlers';

export const IntroductionGuard = (): Observable<UrlTree | boolean> => {
  const shouldShowIntroductionQueryHandler: ShouldShowIntroductionQueryHandler = inject(
    ShouldShowIntroductionQueryHandler
  );
  const authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  const userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);
  const router: Router = inject(Router);

  return authClientProvider.isAuthed$.pipe(
    take(1),
    switchMap((isAuthed: boolean) => {
      if (!isAuthed) return of(true);

      return userDataProvider.userData$.pipe(
        filter((userData: UserModel) => !!userData.userId),
        take(1),
        switchMap((userData: UserModel) => shouldShowIntroductionQueryHandler.shouldShow(userData.userId)),
        map((shouldShow: boolean) => (shouldShow ? router.createUrlTree([AppRoutes.INTRODUCTION]) : true))
      );
    })
  );
};
